// For date/time formatting, stick to Material Design guidelines
// unless a "Homee Rule" supersedes it.
//
// Material Guidelines:
// https://material.io/design/communication/data-formats.html#date-and-time
//
// Homee Guidelines:
// https://zeroheight.com/83195d329/p/060364-grammar--mechanics/t/08e4e2
/**
 * @external https://charbase.com/2013-unicode-en-dash
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    API_DATE_FORMAT: function() {
        return API_DATE_FORMAT;
    },
    DATE_FORMAT: function() {
        return DATE_FORMAT;
    },
    DATE_FORMAT_NO_YEAR: function() {
        return DATE_FORMAT_NO_YEAR;
    },
    DATE_NUMERIC_FORMAT: function() {
        return DATE_NUMERIC_FORMAT;
    },
    DATE_SHORT_FORMAT: function() {
        return DATE_SHORT_FORMAT;
    },
    DAY_MONTH_DATE_FORMAT: function() {
        return DAY_MONTH_DATE_FORMAT;
    },
    DAY_SHORT_FORMAT: function() {
        return DAY_SHORT_FORMAT;
    },
    EN_DASH: function() {
        return EN_DASH;
    },
    MONTH_DATE_FORMAT: function() {
        return MONTH_DATE_FORMAT;
    },
    TIME_FORMAT: function() {
        return TIME_FORMAT;
    },
    UNIX_TIMESTAMP_FORMAT: function() {
        return UNIX_TIMESTAMP_FORMAT;
    }
});
const EN_DASH = '\u2013';
const API_DATE_FORMAT = 'YYYY-MM-DD';
const DATE_FORMAT = 'll';
const DATE_FORMAT_NO_YEAR = 'MMM D';
const TIME_FORMAT = 'LT';
const DATE_SHORT_FORMAT = 'ddd, MMM D';
const DATE_NUMERIC_FORMAT = 'L';
const DAY_MONTH_DATE_FORMAT = 'dddd, MMMM D';
const MONTH_DATE_FORMAT = 'MMM D';
const DAY_SHORT_FORMAT = 'ddd';
const UNIX_TIMESTAMP_FORMAT = 'X';

//# sourceMappingURL=date.constants.js.map